import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/seats/license.seats.limit.mutation.gql"
import type {
  LicenseSeatLimitMutation,
  LicenseSeatLimitMutationVariables,
} from "@/v2-backoffice-client/license/seats/__types__/license.seats.limit.mutation"

type Options = MutationHookOptions<
  LicenseSeatLimitMutation,
  LicenseSeatLimitMutationVariables
>

export function useLicenseSeatLimitMutation(options?: Options) {
  return useMutation<
    LicenseSeatLimitMutation,
    LicenseSeatLimitMutationVariables
  >(mutation, options)
}
